<template>
  <div class="app-body d-flex justify-content-center" ref="appbody">
    <div class="d-flex flex-column m-4">
      <div class="justify-content-start" v-if="ready && !networkError">
        <h1>T&C's</h1>
        <p>At AFTV you need to know all the do's and don'ts for using our app and web. Get all the info you need for our rules of fan engagement.</p>
        <p>You can find our <a href="UFFTermsAndConditionsV1.html" target="_blank">Terms & Conditions here</a>.</p>
        <h1>Your privacy</h1>
        <p v-html="termsSummary"></p>
        <p>You can find our <a :href="termsLink" target="_blank">Privacy Policy here</a>.</p>
        <p v-html="consentSummary"></p>
        <p>You can find our <a :href="consentLink" target="_blank">Cookie Policy here</a>.</p>
        <div v-for="option in consentOptions" :key="option.key" class="custom-control custom-checkbox mb-2">
          <input type="checkbox" class="custom-control-input" :id="option.key" :value="option.key" v-model="checkedOptions" />
          <label class="custom-control-label" :for="option.key">{{ option.description }}</label>
        </div>
      </div>
      <div class="d-flex justify-content-around mt-3" v-if="this.ready">
        <button class="primary" width="auto" v-on:click="onSave">Save</button>
      </div>
    </div>
    <div id="networkError" class="network-error d-flex flex-column align-items-center" v-if="networkError">
      <span>Please check your network connection and try again.</span>
      <button class="primary ml-0 mt-3 mb-4" @click="loadPrefs">Retry</button>
    </div>
  </div>
</template>

<script>
import { spinnakerApi } from '../js/SpinnakerApi.js'
import { DataConsentUtils } from '../js/DataConsentUtils.js'

const dataConsentUtils = new DataConsentUtils(spinnakerApi)

export default {
  data: function () {
    return {
      ready: false,
      accountSummary: null,
      termsVersion: null,
      termsLink: null,
      termsSummary: null,
      consentVersion: null,
      consentLink: null,
      consentSummary: null,
      consentOptions: null,
      checkedOptions: [],
      networkError: false
    }
  },
  name: 'dataConsent',
  async created () {
    await this.loadPrefs()
  },
  methods: {
    async loadPrefs () {
      this.$store.commit('showLoading')

      this.ready = false
      this.networkError = false
      try {
        this.accountSummary = await spinnakerApi.fetchAccountSummary()
        const consentInfo = await dataConsentUtils.fetchDataConsentInfo(this.accountSummary)

        this.termsVersion = consentInfo.termsVersion
        this.termsLink = consentInfo.termsLink
        this.termsSummary = consentInfo.termsSummary
        this.consentVersion = consentInfo.consentVersion
        this.consentLink = consentInfo.consentLink
        this.consentSummary = consentInfo.consentSummary
        this.consentOptions = consentInfo.consentOptions
        this.checkedOptions = consentInfo.consentOptionKeysSelected

        this.ready = true
      } catch (err) {
        this.networkError = true
      }
      this.$store.commit('hideLoading')
    },
    async onSave () {
      this.$store.commit('showLoading')

      let consentChoices = {}
      for (const option of this.consentOptions) {
        consentChoices[option.key] = this.checkedOptions.indexOf(option.key) > -1
      }
      await dataConsentUtils.recordChoices(
        this.accountSummary,
        this.termsVersion,
        this.consentVersion,
        consentChoices)

      this.$store.commit('hideLoading')

      this.goBack()
    },
    goBack () {
      this.$store.commit('navigation/goBack')
    }
  }
}

</script>
